(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/service/transfer-service.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/service/transfer-service.js');
'use strict';

const jupiterHelper = svs.arena.service.jupiterHelper;
const postDepositToTeamAsync = async (amount, teamId) => {
  const options = {
    method: 'POST',
    path: "/social/2/syndicates/".concat(teamId, "/transfertosyn"),
    data: {
      transAmount: svs.utils.format.CurrencyAsJupiterString(amount)
    }
  };
  const _await$jupiterHelper$ = await jupiterHelper.streamlinedJupiterCall(options),
    data = _await$jupiterHelper$.data,
    error = _await$jupiterHelper$.error;
  return {
    data: data !== null && data !== void 0 && data.syndicateAmounts ? {
      playerAccountBalance: data.playerAccountBalance,
      memberBalance: data.memberBalance,
      syndicateBalance: data.syndicateAmounts.syndicateBalance,
      playableAmount: data.syndicateAmounts.playableAmount
    } : null,
    error
  };
};
const exportedFunctions = {
  postDepositToTeamAsync
};
svs.arena.service.transferService = exportedFunctions;

 })(window);